import Component from "../abstracts/Component";
import {Matchmq} from "../utils/ResolutionHandler";

export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]',
      fitersInput: '.js-filters-checkbox',
      trackingPayload: '[data-tracking-payload]',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#sl__search__input',
    }
  }

  get trackingLabel(){
    return {
      NEW_ARRIVALS:"new_arrivals",
      OUR_FAVORITES:"our_favorites",
      PRICE_ASC:"price_asc",
      PRICE_DESC:"price_desc",
      REC_FOR_YOU:"rec_for_you",
      SALES:"sales",
      SOLR_SORTING:"solr_sorting",
      T2SELL_SORTING:"t2s_sorting"
    }
  }

  getSortTypeTracking(sortValue) {
    if (!sortValue) {
      return '';
    }

    if (sortValue.startsWith('rank')) {
      return this.trackingLabel.REC_FOR_YOU;
    }

    switch (sortValue) {
        case 'new-arrival':
          return this.trackingLabel.NEW_ARRIVALS;
        case 'price-asc':
        case 'price-asc-sale':
          return this.trackingLabel.PRICE_ASC;
        case 'price-desc':
        case 'price-desc-sale':
          return this.trackingLabel.PRICE_DESC;
        case 'sale':
          return this.trackingLabel.SALES;
        case 'topRated':
          return this.trackingLabel.OUR_FAVORITES;
        default:
          return '';
    }
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;
    try {
      if ($(el).is('[data-tracking-payload]')) return [$(el)?.data()];
      if (list == true) {
        elements = $(el).find(this.SELECTORS.trackingPayload);
      } else {
        elements = $(el)
          .closest(this.SELECTORS.dataTracking)
          .find(this.SELECTORS.trackingPayload);
      }

      if (elements.length < 1) {
        elements = $(el).prev(this.SELECTORS.trackingPayload);
      }

      let products = [];
      if (Array.isArray(elements)) {
        elements.each(function () {
          products.push($(this).data());
        });
      } else if (elements && elements.data()) {
        products = [elements.data()];
      } else {
        console.error('Invalid elements:', elements);
      }
      return products;
    } catch (error) {
      console.error('Error retrieving products:', error);
      return [];
    }
  }

  findCarouselType(el) {
    const carouselType = el.parentElement.getAttribute('data-carousel-type');
    if (carouselType) return carouselType;
    return this.findCarouselType(el.parentElement);
  }

  addToWishHelper(products, productCode) {
    return new Promise((resolve, reject) => {
      const findIndex = products.findIndex(elem => {
        return String(elem?.id) === String(productCode);
      });
      if (findIndex < 0) {
        reject("No prod found");
      }
      const product = products[findIndex];
      resolve(product);
    });
  }

  getProductsArray(productCode) {
    const selectors = [
      `[data-tracking-payload][data-code="${productCode}"]`,
      `[data-product-id="${productCode}"]`,
      `[data-id="${productCode}"]`,
      `[data-code="${productCode}"]`,
      `[data-size-value="${productCode}"]`
    ];
    console.log(selectors);
    for (const selector of selectors) {
      const productsArray = document.querySelectorAll(selector);
      if (productsArray.length > 0) {
        return productsArray;
      }
    }
  
    return [];
  }

  handleWishlistAddByString(productCode) {
    const productsArray = this.getProductsArray(productCode);
    if (productsArray.length < 1 && typeof products === "undefined") {
      this.warn("No product found for code: " + productCode);
      return;
    }
    const productData = this.getTrackingPayloadData(productsArray, false);
    const data = productData?.length > 0 ? productData : products ;
    if (data) {
      this.addToWishHelper(data, productCode)
        .then(product => {
          utag.wishlist_add(product);
        })
        .catch(() => {
          this.warn("Error during addToWishHelper execution");
        });
    } else {
      this.warn("No valid data for productCode: " + productCode);
    }
  }

  handleWishlistAddByObject(params) {
    let productCode = params?.productCode;
    if (!productCode) {
      productCode = params?.code;
      if(!productCode){
        this.warn("No productCode provided in params");
        return;
      }
    }
    const productsArray = this.getProductsArray(productCode);
    const productData = productsArray.length > 0 ? this.getTrackingPayloadData(productsArray, false) : null;
    const data = typeof products !== "undefined" ? products : productData;
    if (!data) {
      this.warn("No valid product data found for code: " + productCode);
      return;
    }

    this.addToWishHelper(data, productCode)
      .then(product => {
        utag.wishlist_add(product);
      })
      .catch((error) => {
        this.warn("Error during addToWishHelper execution",error);
      });
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: (payload) => {
        if (payload != null) {
          let products = this.getTrackingPayloadData(payload, true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          try {
            this.log("tracking loadMore event with " + products.length + " more products");
            window.listViewMore(products);
          } catch (e) {
            this.log("listViewMore tracking function not available");
          }
        }
      },
      loadMoreSearchPage: (payload) => {
        if (payload != null) {
          let products = this.getTrackingPayloadData(payload, true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          try {
            this.log("tracking loadMoreSearchPage event with " + products.length + " more products");
            window.searchViewMore(products);
          } catch (e) {
            this.log("searchViewMore tracking function not available");
          }
        }
      },

      lookbookView: (productsCard) => {
        const data = {};
        if (Array.isArray(productsCard)) {
          let products = productsCard.map(prod => prod?.$component);
          products = this.getTrackingPayloadData(products,true);
          data.productList = products;
        }

        if (Object.keys(utag?.data).length > 0) {
          const pageName = utag.data['page_3_level'] ?? "";
          data.page_name = `${pageName}:lookbook:detail`;
        }
        data.event_name = "lookbook_detail";
        utag.view(data);
      },
      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];
          // TODO: add other templates..
          if (typeof product.template !== 'undefined') {
            if ("category-page" == product.template || "na:t-editorial-listing" == product.template || "na:t-editorial" == product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if (product.template == "product-page") {
              try {
                this.log("tracking listCarouselClick event for product: " + product.id);
                if($(el).closest('.w-complete-look').data('carouselType')){
                  let type = $(el).closest('.w-complete-look').data('carouselType');
                  let carouselName = type;
                  if(type === 'google-rec'){
                    carouselName = $('#servingConfigId', $(el).closest('.w-complete-look'))[0].value;
                  }
                  if (type === 'completeTheLook') {
                    carouselName = 'wear_with_it';
                  }
                  if (type === '' || type == 'undefined' || type === 'manualSku') {
                    carouselName = 'generic-carousel';
                  }
                  window.listCarouselClick(carouselName, product);
                } else {
                  window.listCarouselClick('generic-carousel', product);
                }
              } catch (e) {
                this.warn("listCarouselClick tracking function not available");
              }
            } else if ("search-page" == product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch (e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            }
          }
          this.algoliaTracking(product);
        }
      },
      lookView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking listProdClick event for product: " + product.id);
            window.listProdClick(product);
          } catch (e) {
            this.warn("listProdClick tracking function not available");
          }
        }
      },
      //tracks products in HP/Editorial components
      carouselView: (params, el) => {
        console.log({el})
        if (el) {
          let carouselType = this.findCarouselType(el);
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          //fallback in case of empty name
          if (carouselType == 'completeTheLook') {
            carouselType = 'wear_with_it';
          }
          if (carouselType == 'google-rec') {
            carouselType = $($(el).parents('.w-complete-look').find('#servingConfigId'))[0].value;
          }
          if (carouselType == '' || carouselType == 'undefined' || carouselType == 'manualSku' || carouselType == 'productSku') {
            carouselType = 'generic-carousel';
          }
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick(carouselType, product);
          } catch (e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      wishlistAdd: params => {
        if (typeof params === "string") {
          this.handleWishlistAddByString(params);
        } else {
          this.handleWishlistAddByObject(params);
        }
      },
      //called from AddToCartComponent.js
      addToCart: (params) => {
        try {
          if (typeof params === 'string' && products && Array.isArray(products) && products.length > 0) {
            const prodCode = params.slice(0,-1);
            const prodIndex = products.findIndex(p => p?.id === prodCode);
            if (prodIndex > -1) {
              try {
                this.log(`Tracking add to cart event with code: ${prodCode}`);    
                const product = products[prodIndex];
                if (product) {
                  utag.cart_add(';' + product);
                  return;
                }
              } catch (e) {
                this.warn(`Utag tracking not available`);
              }
            }
          }
        } catch (error) {
          console.error("Failed to select product object");
        } 
        
        try {
          let productCode = params.productCode || params;
          if (typeof productCode === 'undefined') {
            this.warn('no productCode found');
            return;
          }
          const shortProdCode = productCode?.slice(0,-1);
          const productsArray = this.getProductsArray(shortProdCode);
          if (productsArray.length < 1 && products) {
            this.warn("No product found for code: " + shortProdCode);
            return;
          }
          const productData = this.getTrackingPayloadData(productsArray, false);
          let pData = productData?.length > 0 ? productData[0] : null ;
          if(!pData){
            this.warn('no productCode found');
            pData = params?.productCode || params;
          }
          this.log('tracking add to cart event with code: ' + productCode);
          utag.cart_add(';' + pData);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      addGiftcardToCart: params => {
        if (typeof params.value === 'undefined') {
          this.warn('no valid giftcard');
          return;
        }
        try {
          this.log('tracking add giftcard to cart event with code: ' + params.code);
          var link_data = new Object();
          link_data['event_category'] = 'gift card';
          link_data['event_action'] = 'add to cart';
          link_data['event_label'] = 'giftcart ' + params.value;
          link_data['event_type'] = 'giftcart_add_to_cart';
          utag.link(link_data);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      whatsappStart: () => {
        utag.link({
          event_name: "whatsapp_start"
        });
      },
      removeProduct: (params) => {
        let productCode = params.productcode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking removeProduct event with productCode: ' + params.productcode);
          utag.cart_remove_click(productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        let productCode = params.productcode;
        let price = params.price;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking removeQuantity event with productCode: ' + params.productcode);
          utag.cart_minus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking addQuantity event with productCode: ' + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        this.log('[Tracking] NL-Subscription, type: ' + type + ' pos: ' + pos);
        ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
      },
      formisimo: (params) => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        let code = params;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        this.log('tracking sizeSelection event with code: ' + code);
        try {
          utag.size_selection();
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      notifyMe: (params) => {
        let code = params;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking back in stock event with code: ' + code);
          utag.back_in_stock();
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }
        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from FiltersComponent.js
      filterTracking: (facetCode, facetValue) => {
        if (facetCode != null && facetValue != null) {
          this.log("Triggering filter " + facetCode + ": " + facetValue);
          try {
            this.log('tracking link event: ' + facetValue);
            if (facetCode === 'sortBy') {
              const sortingType = this.getSortTypeTracking(facetValue);
              let sortingMethod = '';
              if (facetValue.includes('rank')) {
                sortingMethod = 't2s_sorting';
              } else {
                sortingMethod = 'solr_sorting';
              }
              utag.link({
                filter: facetCode + ":" + facetValue,
                event_name: "filter_usage",
                productList: products,
                sorting_type: sortingType,
                sorting_method: sortingMethod
              });
            } else {
              utag.link({
                filter: facetCode + ":" + facetValue,
                event_name: "filter_usage",
                productList: products
              });
            }
          } catch (e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      startChat: () => {
        utag.link({
          event_name: "chat_start"
        });
      },
      login: () => {
        try {
          utag.link({
            event_name: "login",
            login_type: "email"
          })
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      socialLogin: (type) => {
        utag.link({
          event_name: "login",
          login_type: type
        })
      },
      signup: (country) => {
        console.log(country);
        try {
          utag.link({
            event_name: "sign_up",
            event_method: "manual",
            store_country: country,
          })
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      signupSocial: (type) => {
        try {
          utag.link({
            event_name: "sign_up",
            event_method: type,
            // store_country: country,
          })
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      socialAccess: (type) => {
        try {
          utag.link({
            event_name: "social_access",
            event_detail: type
          })
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      deleteChat: () => {
        utag.link({
          event_name: "chat_delete"
        });
      },
      newsletterSubscribe: (params) => {
        let position = params.trackingPosition;
        this.log("Newsletter subscribe " + position);
        try {
          utag.link({
            event_name: "newsletter_subscribe",
            form_type: position
          });
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      shortcutCategoryView: (params) => {
        try {
          this.log('Tracking shortcut category click: ' + params.shortcutLabel);
          var data = new Object();
          data['event_name'] = 'select_content';
          data['event_location'] = params.shortcutNumber; // es. shortcut-micro_1, shortcut-macro_4 …
          data['event_detail'] = params.shortcutLabel; // es. our selection, clothing, pantaloni, abiti, …
          data['content_type'] = params.shortcutType; // es. shortcut-micro, shortcut-macro…
          utag.link(data)
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      payPalPayment: (mode) => {
        this.log('Tracking PayPal payment: ' + mode);
        try {
          utag.link({
            event_name: 'paypal_pay',
            paypal_button: mode
          });
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      zoomLayer: (mode, index) => {
        this.log('Tracking zoom layer: ' + mode + ` ${index}`);
        try {
          if (index) window.zoom_layer(mode, index);
          else window.zoom_layer(mode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      }
    }
  }

  algoliaTracking(product) {
    let ctx = this;
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");

    try {
      ctx.log('Algolia click: ' + product);
      product.position = product.position + 1; //Algolia is 1-based, not 0-based
      ctx.log("Algolia " + product.position + ' ' + product.id);
      $.ajax({
        url: contextPath + '/action/ajax/algolia-product-position',
        type: 'POST',
        cache: 'false',
        data: {
          position: product.position,
        },
        success: function (data) {
          ctx.log('algolia success')
        },
        error: function (errorObj, textStatus, errorThrown) {
          ctx.warn('algolia error', errorThrown)
        }
      });
    } catch (e) {
      ctx.warn("algolia error: ", e);
    }
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success";
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  carouselOnLoad() {
    if($('.w-editorial-products-carousel.gallery').length){
      $('.w-editorial-products-carousel.gallery')[0].querySelectorAll('.w-editorial-products-carousel-wrapper').forEach((carousel) => {
        if (carousel == null) {
          this.log('carousel not found');
          return;
        }
        let carouselType = carousel.dataset.carouselType;
        //fallback in case of empty name
        if (carouselType == 'completeTheLook') {
          carouselType = 'wear_with_it';
        }
        if(carouselType == 'google-rec' && $('#servingConfigId').length){
          carouselType = $('#servingConfigId', carousel)[0].value;
        }
        if (carouselType == '' || carouselType == 'undefined' || carouselType == 'manualSku' || carouselType == 'productSku') {
          carouselType = 'generic-carousel';
        }
        try {
          let products = this.getTrackingPayloadData($('.slick-track',carousel)[0].children, true);
          if (products.length == 0 || typeof products === 'undefined') {
            this.log("no products found in " + carouselType + " carousel");
            return;
          }
          try {
            this.log("tracking '" + carouselType + "' carousel with " + products.length + " products");
            window.listCarouselImpression(carouselType, products);
          } catch (e) {
            this.warn("listCarouselImpression tracking not available");
          }
        } catch (e) {
          this.warn('carousel tracking not available');
        }
      });
    }
    document.querySelectorAll('.w-complete-look').forEach((carousel) => {
      if (carousel == null) {
        this.log('carousel not found');
        return;
      }
      let carouselType = carousel.dataset.carouselType;
      //fallback in case of empty name
      if (carouselType == '' || carouselType == 'undefined' || carouselType == 'manualSku') {
        carouselType = 'generic-carousel';
      }
      if (carouselType == 'completeTheLook') {
        carouselType = 'wear_with_it';
      }
      if(carouselType == 'google-rec' && $('#servingConfigId').length){
        carouselType = $('#servingConfigId', carousel)[0].value;
      }
      try {
        let products = this.getTrackingPayloadData($('.w-c-l__wrapper',carousel)[0].children, true);
        if (products.length == 0 || typeof products === 'undefined') {
          this.log("no products found in " + carouselType + " carousel");
          return;
        }
        try {
          this.log("tracking '" + carouselType + "' carousel with " + products.length + " products");
          window.listCarouselImpression(carouselType, products);
        } catch (e) {
          this.warn("listCarouselImpression tracking not available");
        }
      } catch (e) {
        this.warn('carousel tracking not available');
      }
    });
    document.querySelectorAll('.w-editorial-promo').forEach((carousel) => {
      if (carousel == null) {
        this.log('carousel not found');
        return;
      }
      let carouselType = carousel.dataset.carouselType;
      //fallback in case of empty name
      if (carouselType == 'completeTheLook') {
        carouselType = 'wear_with_it';
      }
      if(carouselType == 'google-rec' && $('#servingConfigId').length){
        carouselType = $('#servingConfigId', carousel)[0].value;
      }
      if (carouselType == '' || carouselType == 'undefined' || carouselType == 'manualSku' || carouselType == 'productSku') {
        carouselType = 'generic-carousel';
      }
      try {
        let products = this.getTrackingPayloadData($('.w-c-l__container-wrapper',carousel)[0].children, true);
        if (products.length == 0 || typeof products === 'undefined') {
          this.log("no products found in " + carouselType + " carousel");
          return;
        }
        try {
          this.log("tracking '" + carouselType + "' carousel with " + products.length + " products");
          window.listCarouselImpression(carouselType, products);
        } catch (e) {
          this.warn("listCarouselImpression tracking not available");
        }
      } catch (e) {
        this.warn('carousel tracking not available');
      }
    });
    //tracks "complete-the-look" carousels in PdP
    if (document.querySelector('body').getAttribute('data-controller') === 'Product') {
      let elem = document.querySelector('[data-complete-look]');
      if (elem == null) {
        this.log('"complete-the-look" carousel not found');
        return;
      }
      let elemName = elem.id;
      try {
        let products = this.getTrackingPayloadData(elem.children, true);
        if (products.length == 0 || typeof products === 'undefined') {
          this.warn("no products found in " + elemName + " carousel");
          return;
        }
        try {
          this.log("tracking '" + elemName + "' carousel with " + products.length + " products");
          window.listCarouselImpression(elemName, products);
        } catch (e) {
          this.warn("listCarouselImpression tracking not available");
        }
      } catch (e) {
        this.warn('"complete-your-outfit" carousel tracking not available');
      }
    }
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data['bs.tab'] != 'undefined') {
        delete data['bs.tab'];
      }
      this.log('[Tracking] tracking action caught: ' + action + ' - with params: ' + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('[Tracking] no tracking manager found for action ' + action);
    }
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        let data = $(event.currentTarget).data();
        let action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }
    }, 'body', this.SELECTORS.dataTracking);

    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $('body').on('track', (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener('load', (event) => {
      this.carouselOnLoad();
    });
  }
}